import { render, staticRenderFns } from "./comment-menu.vue?vue&type=template&id=de98834c"
import script from "./comment-menu.vue?vue&type=script&lang=js"
export * from "./comment-menu.vue?vue&type=script&lang=js"
import style0 from "./comment-menu.vue?vue&type=style&index=0&id=de98834c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports